import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-shared-note',
  templateUrl: './confirm-shared-note.component.html',
  styleUrls: ['./confirm-shared-note.component.scss']
})
export class ConfirmSharedNoteComponent implements OnInit {

  @Input() confirmSave: () => void;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }

  closeModal() {
    this.bsModalRef.hide();
  }
  save() {
    this.bsModalRef.hide();
    this.confirmSave();
  }

  cancel() {
    this.bsModalRef.hide();
  }

}
